<template>
    <div class="btn-group">
        <template v-if="hasMultiple">
            <a href="#" @click.prevent="toggleMenu" class="dropdown-toggle" :class="{open: showMenu}">
                <span>{{ getOptionLabel(selectedOption) }}</span>
                <svg viewBox="0 0 172.43 242.72" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="m70.3 121.36-70.3-70.3 51.06-51.06 121.37 121.36-121.37 121.36-51.06-51.06z"
                    ></path>
                </svg>
            </a>

            <transition name="fade-fast">
                <ul class="dropdown-menu" v-if="showMenu">
                    <li v-for="option in options" :key="option">
                        <a
                            href="#"
                            @click.prevent="updateOption(option)"
                            :class="{active: selectedOption === option}"
                        >{{ getOptionLabel(option) }}</a>
                    </li>
                </ul>
            </transition>
        </template>

        <template v-else>
            <div class="dropdown-toggle static-only">
                <span>{{ selectedOption }}</span>
            </div>
        </template>
    </div>
</template>

<script>

export default {

    data() {
        return {
            selectedOption: "",
            showMenu: false,
            selected: null,
            hasMultiple: true,
        };
    },

    props: {
        options: {
            type: Array,
            default: null
        }
    },

    watch: {

        options: {
            immediate: true,
            handler(newVal, oldVal) {

                if (!this.options) return;

                this.showMenu = false;
                this.options = newVal;
                this.hasMultiple = this.options.length > 1;
                this.selectedOption = this.options[0];
            },
        },
    },

    methods: {
        updateOption(option) {
            this.selectedOption = option;
            this.showMenu = false;
            this.$emit("updateOption", this.selectedOption);
        },
        toggleMenu() {
            this.showMenu = !this.showMenu;
        },
        getOptionLabel(optionItem) {

            return (optionItem === '2015') ? 'Pre-2016' : optionItem;
        }
    },

    mounted() {

        window.addEventListener('click', (e) => {

            // close dropdown when clicked outside
            if (!this.$el.contains(e.target)){
                this.showMenu = false
            } 
        });
    },
};
</script>

<style scoped lang="scss">

    .btn-group {

        position: relative;
        width: 100%;
        background: linear-gradient(#ff3a1e, #dc341c);
        border-radius: 5px;

        .dropdown-toggle {

            padding: 15px * 0.8 20px * 0.8;
            margin: 0;
            cursor: pointer;
            display: block;
            text-decoration: none;
            line-height: 16px * 0.9;

            &.static-only {

                cursor: default;
            }

            @media screen and (min-width: 768px) {

                padding: 15px * 0.9 20px * 0.9;
                line-height: 16px * 0.95;
            }

            @media screen and (min-width: 1024px) {

                padding: 15px 20px;
                line-height: 16px;
            }

            span {
                font-size: 16px * 0.8;
                font-weight: 600;
                letter-spacing: 0.5px;
                color: #fff;
                text-transform: capitalize;
                padding: 0;
                width: calc(100% - 20px * 0.8);
                transition: all 0.35s ease 0s;
                display: block;

                @media screen and (min-width: 768px) {

                    width: calc(100% - 20px * 0.9);
                    font-size: 16px * 0.9;
                }

                @media screen and (min-width: 1024px) {

                    width: calc(100% - 20px);
                    font-size: 16px;
                }
            }

            svg {
                position: absolute;
                top: 50%;
                right: 20px * 0.8;
                width: 10px;
                transform: translateY(-50%) rotate(90deg);
                height: auto;
                fill: #fff;
                pointer-events: none;
                transition: all 0.35s ease 0s;

                @media screen and (min-width: 768px) {

                    right: 20px * 0.9;
                }

                @media screen and (min-width: 1024px) {

                    right: 20px;
                }
            }

            &.open {

                svg {
                    transform: translateY(-50%) rotate(-90deg);
                }
            }
        }

        .dropdown-menu {
            position: absolute;
            top: 100%;
            left: 0;
            z-index: 1;
            width: 100%;
            padding: 0;
            margin: 5px 0 0 0;
            background: linear-gradient(#ff3a1e, #dc341c);
            border-radius: 5px;
            box-shadow: 0 0 15px rgba(#000, 0.2);
            overflow: hidden;

            li {
                list-style: none;
                width: 100%;
                position: relative;
                margin: 0;

                a {
                    color: rgba(#fff, 0.5);
                    text-transform: capitalize;
                    text-decoration: none;
                    display: block;
                    font-size: 16px * 0.8;
                    line-height: 16px * 0.8;
                    font-weight: 600;
                    letter-spacing: 0.5px;
                    padding: 15px * 0.8 20px * 0.8;
                    margin: 0;
                    transition: all 0.35s ease 0s;

                    @media screen and (min-width: 768px) {

                        font-size: 16px * 0.9;
                        line-height: 16px * 0.9;
                        padding: 15px * 0.9 20px * 0.9;
                    }

                    @media screen and (min-width: 1024px) {

                        font-size: 16px;
                        line-height: 16px;
                        padding: 15px 20px;
                    }

                    &.active {
                        color: #fff;
                        background-color: rgba(#fff, 0.1);
                    }
                }
            }
        }
    }

    .fade-fast-enter-active {

        transition: all 0.25s ease 0s;
    }
    .fade-fast-leave-active {

        transition: all 0.25s ease 0s;
    }
    .fade-fast-enter, .fade-fast-leave-to {

        opacity: 0;
    }

</style>